module.exports = __webpack_public_path__ + "static/media/1POLICY46.31635ed8.jpg";